import { POST_NEW_TRADE_OFFER, FETCH_POSTED_OFFERS } from '../constants/postedOffersTypes';

export function postNewTradeOffer(params) {
  return {
    type: POST_NEW_TRADE_OFFER,
    payload: params
  };
}
export function fetchPostedOffers(params) {
  return {
    type: FETCH_POSTED_OFFERS,
    payload: params
  };
}



// WEBPACK FOOTER //
// ./app/actions/postedOffersActions.js